import { useEffect, useState } from 'react';

/** A tela aberta atravessa o corte de sexta: o relógio é relido a cada meio minuto. */
const REFRESH_MS = 30_000;

/** O instante atual, atualizado a cada 30 segundos. */
export function useNow(): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), REFRESH_MS);
    return () => clearInterval(id);
  }, []);

  return now;
}
